export default __webpack_public_path__ + "static/media/cvv.c3f6793e.png";